import './manual-approve.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select/field';
import Calendar from '../../../shared/calendar/main';
import GetConversionsForApprove from './get-conversions-for-approve';

const Form = props => (
	<form className="manual-approve" onSubmit={props.handleSubmit(data => props.requestManualApprove(data))}>
		<div className="control-bar-container">
			<div className="ui-control-bar">
				<div className="ui-control-bar__item-position">
					<div className="manual-approve__element ui-form__element">
						<Field
							name="percent_to_approve"
							placeholder={props.intl('Approve percent')}
							component={InputField}
							showLabel={false}
						/>
					</div>
				</div>
				<div className="ui-control-bar__item modify-item---calendar">
					<div className="ui-control-bar__item-position">
						<Calendar
							{...props.calendar}
							onInit={props.calendarInit}
							onToggle={props.calendarToggle}
							onChange={props.calendarChange}
							onApply={props.calendarApply}
							intl={props.intl}
						/>
					</div>
				</div>
				<div className="ui-control-bar__item modify-item---manual-approve">
					<div className="ui-control-bar__item-position display-flex">
						<button onClick={(e) => { e.preventDefault(); props.clear(); }} className="ui-btn ui-btn-cancel cancel">
							{props.intl('Cancel')}
						</button>
						<button
							onClick={props.toggleRequestForApprovePopup}
							type="button"
							className="ui-btn ui-btn-primary save margin-0-10"
						>
							{props.intl('Apply for approve or restrict approve')}
						</button>
						<GetConversionsForApprove
							getConversionsForApprove={props.getConversionsForApprove}
							intl={props.intl}
							{...props}
						/>
					</div>
				</div>
			</div>
		</div>

		<div className="control-bar-container">
			<div className="ui-control-bar display-flex-column">
				<div className="display-flex">

					<div className="ui-control-bar__item modify-item---filter width-300 min-width-300">
						<div className="manual-approve__element ui-form__element">
							<Field
								name="affiliates"
								placeholder={props.intl('Select affiliate')}
								multi={false}
								options={props.affiliatesLookup}
								component={SelectField}
								showLabel={false}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---filter">
						<div className="manual-approve__element ui-form__element">
							<Field
								name="offers"
								placeholder={props.intl('Select offer')}
								multi={false}
								searchable={true}
								options={props.offersLookup}
								component={SelectField}
								showLabel={false}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---filter width-200">
						<div className="manual-approve__element ui-form__element">
							<Field
								name="countries"
								placeholder={props.intl('Select country')}
								options={props.locationsLookup}
								component={SelectField}
								showLabel={false}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item modify-item---filter position-relative">
						<div className="manual-approve__element ui-form__element sid-input">
							<Field
								name="sid"
								placeholder={props.intl('Select sid')}
								component={InputField}
								showLabel={false}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
);

Form.propTypes = {
	intl: PropTypes.func,
	calendar: PropTypes.object,
	locationsLookup: PropTypes.func,
	affiliatesLookup: PropTypes.func,
	offersLookup: PropTypes.func,
	calendarInit: PropTypes.func,
	calendarToggle: PropTypes.func,
	calendarChange: PropTypes.func,
	calendarApply: PropTypes.func,
	requestManualApprove: PropTypes.func,
	clear: PropTypes.func,
	handleSubmit: PropTypes.func
};
const validate = values => {
	const errors = {};
	validatePercentToApprove(values, errors);
	validateCountries(values, errors);
	validateAffiliates(values, errors);
	return errors;
};

export default reduxForm({
	form: 'manualApproveForm',
	validate
})(Form);

function validatePercentToApprove(values, errors) {
	if (isNaN(Number(values.percent_to_approve))) {
		errors.percent_to_approve = 'Must be a number';
	} else if (values.percent_to_approve > 100) {
		errors.percent_to_approve = 'Should be <= 100';
	} else if (values.percent_to_approve < 1) {
		errors.percent_to_approve = 'Should be >= 1';
	}
}

function validateCountries(values, errors) {
	if (!values.countries || !values.countries.length) {
		errors.countries = 'At least one country should be selected';
	}
}

function validateAffiliates(values, errors) {
	if (!values.affiliates || !values.affiliates.length) {
		errors.affiliates = 'At least one affiliate should be selected';
	}
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve-requests/components/forms/manual-approve.js